<template>
  <button
    id="ma-btn-create-assessment"
    data-cy="ma-btn-create-assessment"
    :class="`tw-flex tw-items-center tw-justify-between tw-w-full tw-leading-[130%] tw-bg-[#387DFF] tw-text-white tw-rounded-md ${btnStyle}`"
  >
    <span
      class="tw-text-[20px] tw-font-semibold tw-leading-[130%] tw-mr-[7px]"
      >{{ title }}</span
    >

    <div
      class="tw-flex tw-items-center tw-justify-center tw-w-[26px] tw-h-[26px] tw-min-w-[26px] tw-min-h-[26px] tw-bg-[#FFFFFF] tw-rounded-[50%]"
    >
      <span class="tw-text-[#387DFF] tw-text-base tw-font-medium tw-mt-[2px]"
        >+</span
      >
    </div>
  </button>
</template>

<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";

defineProps({
  title: {
    type: String,
    default: getComponentUiText("app-assessment-button-create-button-1"),
    required: false,
  },
  btnStyle: {
    type: String,
    default: "tw-px-[25px] tw-py-[16px]",
    required: false,
  },
});
</script>
